/** The build version of this package (e.g. "0.16.0") */
export const PACKAGE_VERSION: string = import.meta.env.PACKAGE_VERSION;
